

import wx from 'weixin-js-sdk';
import cmBlank from '@/components/cmBlank.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'lostCode',
components: {
wx,XTextarea,Group,Popup,PopupHeader,XButton,Radio,cmBlank,TransferDom
},
directives: {
TransferDom
},
data () {
return {
backPop:false,
pickerStatus:false,
blankShow:false,
popBg:false,
id:0,
code:'',
code1:'',
title:'掉签衣物',
grade:0,
setIndex:0,
statusKey:'',
typeKey:0,
pageFlag:2,
hasNext:0,
lastId:0,
list:[],
statusArr:[
{
key:'',
value:'全部',
},
{
key:1,
value:'未认领',
},
{
key:2,
value:'已认领'
},
],
typeArr:[
{
key:1,
value:'衣物',
},
{
key:2,
value:'鞋靴'
},
],
}
},
created(){
this.config();
this.grade = parseInt(this.$func.getLocal('grade'));
},
mounted(){
},
methods:{

copy(val){
this.$func.copy(val,event);
},
selectStatus(index){
this.statusKey = this.statusArr[index].key;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
selectType(index){
this.typeKey = this.typeArr[index].key == this.typeKey ? 0 : this.typeArr[index].key;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
getList(){
this.$api.getLostClothes({code:this.code1,last_id:this.lastId,page_flag:this.pageFlag,status:this.statusKey,factory_id:this.typeKey}).then((res)=>{
if(res){
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
scanQRCode(){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ["barCode"],
success: function (res) {
setTimeout(()=>{
that.code1 = res.resultStr.split(',')[1];
that.search();
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
search(){
this.statusKey = '';
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
barCode(code){
this.$router.push({name:'barOrder',params:{code:code}})
},
copy(val){
this.$func.copy(val,event);
},
addLostCode(id){
this.$router.push({name:'addLostCode',params:{id:id}})
},
closePop(){
this.popBg = false;
this.setIndex = 0;
this.code = '';
},
setCode(index){
this.setIndex = index;
this.code = this.list[index].code;
this.popBg = true;
},
remove (index) {
const id = this.list[index].id;
this.$func.confirm('确认删除？','提示',()=>{
this.$func.startLoading();
this.$api.removeLostClothes({id:id}).then((res)=>{
if(res){
this.list.splice(index,1);
this.$func.endLoading();
this.$func.showToast('操作成功');
}
})
})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
submit(){
let that = this;
if(!this.code){
that.$func.showToast('衣物编码无效');
return ;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$api.setLostClothesCode({code:this.code,id:this.list[this.setIndex].id}).then((res)=>{
if(res){
that.$func.showToast('操作成功');
this.this.list[this.setIndex].code = this.code;
this.code = '';
wx.ready(function () {
let media = document.getElementById("musicBox");
media.src = "https://fcwash.uunbiot.com/uploads/default/operate.mp3"
media.play();
});
}
})
})

},
showPic(item,index) {
wx.previewImage({
current: item[index], // 当前显示图片的http链接
urls: item 
});
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';
this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/lostCode.vue